import { EDHRECIconsType } from '@/components/Icon/Icon'

export const ARTICLES_CACHE_CONTROL = 's-maxage=3600, stale-while-revalidate=300'
export const BORDER_WIDTH = 1
export const CARD_WIDTH = 244
export const GRID_GAP = 8
export const TIMESPANS = [undefined, 'week', 'month', 'year']
export const BRACKETS = ['exhibition', 'core', 'upgraded', 'optimized', 'cedh']
export const COLORS = {
  b: 'Mono-Black',
  bg: 'Golgari',
  bgu: 'Sultai',
  br: 'Rakdos',
  brg: 'Jund',
  brgw: 'Dune-Brood',
  c: 'Colorless',
  colorless: 'Colorless',
  g: 'Mono-Green',
  gu: 'Simic',
  gur: 'Temur',
  gw: 'Selesnya',
  gwu: 'Bant',
  gwub: 'Witch-Maw',
  r: 'Mono-Red',
  rg: 'Gruul',
  rgw: 'Naya',
  rgwu: 'Ink-Treader',
  rw: 'Boros',
  rwb: 'Mardu',
  u: 'Mono-Blue',
  ub: 'Dimir',
  ubr: 'Grixis',
  ubrg: 'Glint-Eye',
  ur: 'Izzet',
  urw: 'Jeskai',
  w: 'Mono-White',
  wb: 'Orzhov',
  wbg: 'Abzan',
  wu: 'Azorius',
  wub: 'Esper',
  wubr: 'Yore-Tiller',
  wubrg: 'Five-Color',
}

export const COLOR_ID_SLUGS = [
  'colorless',
  'mono-white',
  'mono-blue',
  'mono-black',
  'mono-red',
  'mono-green',
  'azorius',
  'dimir',
  'rakdos',
  'gruul',
  'selesnya',
  'orzhov',
  'izzet',
  'golgari',
  'boros',
  'simic',
  'esper',
  'grixis',
  'jund',
  'naya',
  'bant',
  'abzan',
  'jeskai',
  'sultai',
  'mardu',
  'temur',
  'yore-tiller',
  'glint-eye',
  'dune-brood',
  'ink-treader',
  'witch-maw',
  'five-color',
]

// https://www.gdpradvisor.co.uk/gdpr-countries
export const gdprAffectedCountries = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
  'UK',
  // Non-GDPR but similar laws
  'CH',
  'BH',
  'IS',
  'QA',
  'TR',
  'KE',
  'MU',
  'NG',
  'ZA',
  'UG',
  'JP',
  'KR',
  'NZ',
  'AR',
  'BR',
  'UY',
  'CA',
]

export const desktopWidth = 1024

export type Mode = {
  icon?: EDHRECIconsType
  key: string
  skipFetch?: boolean
  value: string
}

export const defaultGroupedBy = 'default'

export const defaultSortedBy = 'default'

export const groupByModes: Mode[] = [
  { icon: 'tableList', key: 'default', skipFetch: true, value: 'Category' },
  { icon: 'tag', key: 'type', value: 'Type' },
  { icon: 'arrowDown19', key: 'mana', value: 'Mana Value' },
  { icon: 'dollarSign', key: 'price', value: 'Price' },
  { icon: 'star', key: 'rarity', value: 'Rarity' },
  { icon: 'calendar', key: 'date', value: 'Release date' },
  { icon: 'tableCellsLarge', key: 'ungrouped', skipFetch: true, value: 'Ungrouped' },
]

export const recaptchaKey = '6Ld7ckoqAAAAACdJC0eF5Ak7de764U3u6RS4BtYi'

export const sortByModes: Mode[] = [
  { key: 'default', skipFetch: true, value: 'Default' },
  { icon: 'percent', key: 'percent', skipFetch: true, value: 'Inclusion' },
  { icon: 'hashtag', key: 'count', skipFetch: true, value: 'Deck Count' },
  { icon: 'angleUp', key: 'lift', skipFetch: true, value: 'Lift' },
  { icon: 'wandMagicSparkles', key: 'synergy', skipFetch: true, value: 'Synergy' },
  { icon: 'font', key: 'name', skipFetch: true, value: 'Name' },
  { icon: 'arrowDown19', key: 'mana', value: 'Mana Value' },
  { icon: 'dollarSign', key: 'price', value: 'Price' },
  { icon: 'calendar', key: 'released_at', value: 'Release date' },
  { key: 'salt', value: 'Salt' },
]

export const tagMap = {
  defender: 'defenders',
  draw: 'card-draw',
  'eldrazi-tokens': 'eldrazi',
  'elemental-tokens': 'elementals',
  'elf-tokens': 'elves',
  enchantments: 'enchantress',
  'energy-counters': 'energy',
  'goblin-tokens': 'goblins',
  'golem-tokens': 'golems',
  'human-tokens': 'humans',
  'insect-tokens': 'insects',
  'knight-tokens': 'knights',
  lands: 'lands-matter',
  'm1-m1-counters': 'minus-1-minus-1-counters',
  'p1-p1-counters': 'plus-1-plus-1-counters',
  pod: 'birthing-pod',
  reanimate: 'reanimator',
  'saproling-tokens': 'saprolings',
  'soldier-tokens': 'soldiers',
  'spirit-tokens': 'spirits',
  'thopter-tokens': 'thopter',
  toughness: 'toughness-matters',
  walls: 'defenders',
  'warrior-tokens': 'warriors',
  'wolf-tokens': 'wolves',
  'zombie-tokens': 'zombies',
}

export const bracketsArticleUrl = 'https://edhrec.com/articles/wotc-introduces-new-bracket-system-for-edh'

export const tcgLandUrl = 'https://www.tcg.land/es/magic-the-gathering/search?onlyInStock=true&via=cardshops-edhrec-com'

export const wordpressCategories = {
  Articles: 4,
  Content: 380,
  Guide: 26504,
}
